import { Link } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

export function DashboardPage() {
  const { user } = useAuth();

  return (
    <div className="page dashboard-page">
      <h2>Welcome back{user?.username ? `, ${user.username}` : ''}</h2>
      <div className="dashboard-grid">
        <Link to="/calculator" className="dashboard-card">
          <h3>Dosing Calculator</h3>
          <p>Calculate precise per-serving cannabinoid content</p>
        </Link>
        <Link to="/recipes" className="dashboard-card">
          <h3>My Recipes</h3>
          <p>View and manage your infused recipes</p>
        </Link>
        <Link to="/journal" className="dashboard-card">
          <h3>Dosing Journal</h3>
          <p>Track your consumption and effects</p>
        </Link>
      </div>
    </div>
  );
}
